import React, {
    useState,
    useEffect,
} from "react"
import { ColorLabeledStatList } from './ot'

const BaseChart3 = ({
    showComponent = [
        "ColorLabeledStatList",
    ],
    baseColorLabeledStatList = {
        title: "建立方式",
        items: [
            { label: "手動建立", value: 28, colorClass: "bg-blue-500" },
            { label: "系統範本", value: 45, colorClass: "bg-purple-500" },
            { label: "智慧生成", value: 17, colorClass: "bg-indigo-500" },
        ]
    },
}, ref) => {
    return (
        <>
            {
                showComponent.includes("ColorLabeledStatList") && (
                    <ColorLabeledStatList {...baseColorLabeledStatList} />
                )
            }
        </>
    )
}

export default BaseChart3
